// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"_s-z","giftOrPromoSelector":"at-z","disabled":"bt-z","subTitle":"ct-z","selectShipAddressMessage":"dt-z","changePayment":"et-z"};